import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';

import FooterButton from './FooterButton';
import SidePanel from './SidePanel';
import stepThreeIllustration from '/public/SiteImages/step3.svg';

import bt from '../../components/commonStyle.css';
import s from './ListPlaceStep1.css';
import updateStep3 from './updateStep3';
import validateStep3 from './validateStep3';

class Description extends Component {

  static propTypes = {
    previousPage: PropTypes.any,
    nextPage: PropTypes.any
  };

  constructor(props) {
    super(props);
    this.state = {
      isDisabled: true,
      chars_left: 500,
      showMinWarning: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.renderDescriptionInput = this.renderDescriptionInput.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { valid } = this.props;
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
  }

  componentDidMount() {
    const { valid, description } = this.props;
    let max_chars = description ? 500 - description.length : 500;
    this.setState({
      chars_left: max_chars,
      showMinWarning: description ? (description.length > 0 && description.length < 50) : false
    });
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { valid } = nextProps;
    const { description } = nextProps;
    let max_chars = description ? 500 - description.length : 500;
    this.setState({
      chars_left: max_chars,
      showMinWarning: description ? (description.length > 0 && description.length < 50) : false
    });
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
  }

  handleChange(event) {
    var input = event.target.value;
    let max_chars = 500;
    this.setState({
      chars_left: max_chars - input.length,
      showMinWarning: input.length > 0 && input.length < 50
    });
  }

  renderDescriptionInput({ input, placeholder, maxLength }) {
    return (
      <textarea
        {...input}
        placeholder={placeholder}
        maxLength={maxLength}
        className={s.titleTextareaField}
        rows={10}
        onChange={(e) => {
          input.onChange(e);
          this.handleChange(e);
        }}
      />
    );
  }

  render() {
    const { handleSubmit, previousPage, nextPage, formPage, step, existingList, description } = this.props;
    const { formatMessage } = this.props.intl;
    const { isDisabled } = this.state;

    let path = "title";

    const currentCount = description ? description.length : 0;

    return (
      <div className={s.eslipinBg}>
        <div className={s.grid}>
          <SidePanel
            badge="Información del alojamiento"
            title={`Nos toca agregar la \n`}
            highlightText="descripción"
            subtitle={`Cuéntales a los huéspedes qué \n hace especial a tu alojamiento`}
            iconImg={stepThreeIllustration}
          />
          <form onSubmit={handleSubmit}>
            <div className={cx(s.stepRightCard, s.titleStepCard)}>
              <div className={s.landingMainContent}>
                {/* Header: Icon + Title + Subtitle */}
                <div className={s.titleHeaderRow}>
                  <div className={s.titleHeaderIcon}>
                    <img src="/SiteIcons/documento.svg" width="70" height="70" />
                  </div>
                  <div className={s.titleHeaderText}>
                    <h2 className={s.titleMainHeading}>Descripción de tu alojamiento</h2>
                    <p className={s.titleSubHeading}>
                      Comparte los detalles que ayudarán a tus huéspedes a saber qué esperar.
                    </p>
                  </div>
                </div>

                {/* Input Card */}
                <div className={s.titleInputContainer}>
                  <Field
                    name="description"
                    component={this.renderDescriptionInput}
                    placeholder="Ej. Departamento moderno en Equipetrol, a pocos minutos de restaurantes y cafeterías. Cuenta con cocina equipada, estacionamiento y un balcón con vista a la ciudad."
                    maxLength={500}
                  />
                  <div className={s.titleCharCounterNew}>
                    {currentCount}/500
                  </div>
                </div>

                {/* Tips Box */}
                <div className={s.titleTipsCard}>
                  <div className={s.titleTipsHeader}>
                    <div className={s.titleTipsIcon}>
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0084FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M9 18h6" />
                        <path d="M10 21h4" />
                        <path d="M12 3a6 6 0 0 0-3.5 10.9c.5.4.8 1 .9 1.6h5.2c.1-.6.4-1.2.9-1.6A6 6 0 0 0 12 3z" />
                      </svg>
                    </div>
                    <span className={s.titleTipsText}>
                      <span className={s.titleTipsTitle}>Tip:</span>{' '}
                      Mencionar la ubicación, las principales comodidades y aquello <br /> que hace diferente a tu alojamiento
                    </span>
                  </div>
                </div>
              </div>
              <FooterButton
                isDisabled={isDisabled}
                previousPage={previousPage}
                previousPagePath={path}
                nextPage={nextPage}
                nextPagePath={"min-max-nights"}
                formPage={formPage}
                step={step}
              /* type="submit" */
              />
            </div>
          </form >
        </div >
      </div>
    );
  }
}

Description = reduxForm({
  form: 'ListPlaceStep3', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: validateStep3,
  onSubmit: updateStep3
})(Description);

const selector = formValueSelector('ListPlaceStep3');

const mapState = (state) => ({
  listingFields: state.listingFields.data,
  description: selector(state, 'description')
});

const mapDispatch = {};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(Description)));